import es from './es';

const resources = {
  es,
};

export const config = {
  resources: resources,
};
